





















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Report, SearchCondition } from '@/modules/report';
import { PublicTypes, getPublicTypeName } from '@/enums/publicTypes';
import { ReadTypes, getReadTypeName } from '@/enums/readTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component
export default class ReportList extends AvaivaledVue {
  private PublicTypes = PublicTypes;
  private getPublicTypeName = getPublicTypeName;
  private ReadTypes = ReadTypes;

  @Prop() private searchCondition: string;

  private showSearchCondition = true;

  get loading(): boolean {
    return this.$store.state.report.loading;
  }

  get countAll(): number {
    if (this.$store.state.report.countAll === 0) {
      return 1;
    } else {
      return this.$store.state.report.countAll;
    }
  }

  get reportList(): Report[] {
    return this.$store.state.report.reportList;
  }

  get condition(): SearchCondition {
    return this.$store.state.report.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private mounted() {
    this.setSearchCondition();
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Report);
  }

  private setSearchCondition() {
    if (!!this.searchCondition) {
      const condition = JSON.parse(this.searchCondition) as SearchCondition;
      this.condition.publicType = condition.publicType;
      this.condition.readType = condition.readType;
      this.condition.tutorIdList = condition.tutorIdList;
      this.condition.dateFrom = condition.dateFrom;
      this.condition.dateTo = condition.dateTo;
      this.condition.keyWord = condition.keyWord;
      this.condition.page = 1;
      this.condition.sort = condition.sort;
    }
  }

  private loadData() {
    this.$store.dispatch('report/searchReports', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private lessonDateFormatter(row: Report) {
    const moment = (this as any).$moment;
    if (!row.lessonStartDate) {
      return '';
    }
    let start: string;
    if (row.lessonStartDate.getHours() === 0 && row.lessonStartDate.getMinutes() === 0) {
      start = moment(row.lessonStartDate).format('YYYY/MM/DD');
    } else {
      start = moment(row.lessonStartDate).format('YYYY/MM/DD H:mm');
    }
    if (!row.lessonEndDate) {
      return start;
    } else {
      if (row.lessonEndDate.getHours() === 0 && row.lessonEndDate.getMinutes() === 0) {
        return `${start} ～ ${moment(row.lessonEndDate).format('YYYY/MM/DD')}`;
      } else {
        return `${start} ～ ${moment(row.lessonEndDate).format('YYYY/MM/DD H:mm')}`;
      }
    }
  }

  private updateDateFormatter(row: Report) {
    if (!row.updateDate) {
      return '';
    } else {
      return (this as any).$moment(row.updateDate).format('YYYY/MM/DD H:mm');
    }
  }

  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = 'updateDate descending';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onPageSizeChange(val: number) {
    this.condition.perPage = val;
  }

  private onRowClick(row: Report) {
    this.$router.push({
      name: 'ReportDetails',
      params: {
        reportId: row.id
      }
    });
  }

  private onCreateReport() {
    this.$router.push({ name: 'ReportCreate' });
  }
}
